import { initialState } from "./state"

export default {
  updateLoading: (state, payload) => (state.loading = payload),
  updateQuestion: (state, payload) => (state.question = payload),
  updateQuestionType: (state, payload) => (state.questionType = payload),
  updadeIsFromBiometry: (state, payload) => (state.isFromBiometry = payload),
  updateSkipBiometry: (state, payload) => (state.skipBiometry = payload),
  updateUuidBiometry: (state, payload) => (state.uuidBiometry = payload),
  updateOrderDate: (state, payload) => (state.orderDate = payload),
  updateOrderCode: (state, payload) => (state.orderCode = payload),
  updateUuidOrder: (state, payload) => (state.uuidOrder = payload),
  updateToken: (state, payload) => (state.token = payload),
  resetScheduling: state => {
    const init_state = initialState()
    Object.keys(state).forEach(key => {
      state[key] = init_state[key]
    })
  }
}
